import { getEnvInfo } from '@didi/webx-js'
import { getStorage } from '@/utils/storage'
import { receiveFlightCoupon } from '@/api/flights'
import store from '@/store'
import { sendEvent } from '@/utils'
import { mpx } from '@didi/es-mpx-creator'


//领取优惠券
export const receiveFlightsCoupon = async ({ params, cb }) => {
    try {
        const { code, msg, data } = await receiveFlightCoupon(params)
        if (code === 200 && data.receiveResult) {
            mpx.showToast({
              title: '领取成功',
              icon: 'success',
            })
            cb && cb()
            sendEvent('updateFlightsCoupon')
        } else {
            mpx.showToast({
              title: data?.message || msg,
              icon: 'none',
            })
        }
    } catch (e) {
        console.log('领券失败了啊！', e)
    }
}

//处理券数据结构
export const handleFlightsCouponData = data => {
    data.unlockCouponInfo = formatData(data?.unlockCouponInfo,0)
    data.toReceiveCouponInfo = formatData(data?.toReceiveCouponInfo,1)
    data.hasReceiveCoupons = formatData(data?.hasReceiveCoupons, 2)
    return data
}

//格式化券数据
export const formatData = (data, type) => {
    return data?.map(item => {
        item.batchExpiredTime = getBatchExpiredTime(item?.batchExpiredTime,item?.remark)
        // 券的状态, 0: 未解锁, 1: 可领取, 2: 已领取
        item.couponStatus = type
        item.maxAmount = getMaxAmount(item?.maxAmount)
        //将item.discount除10且保留一位小数
        item.discount = item?.discount ? (item?.discount / 10) : ''
        return item
    })
}

// 返回券的到期时间, 需要传入 batchExpiredTime
export const getBatchExpiredTime = (batchExpiredTime = '', remark = '') => {
    return batchExpiredTime?.split(' ')?.[0] && remark
        ? remark.substr(0, 2) + batchExpiredTime?.split(' ')?.[0] + remark.substr(2)
        : ''
}

//最大折扣
export const getMaxAmount = (maxAmount) => {
    return maxAmount ? `最高抵${maxAmount / 100}元` : ''
}

//处理天降数据
export const handleFlightsFallingData = (list = []) => {
    return list?.map(item => {
        item.discount = item?.discount ? (item?.discount / 10).toFixed(1) : ''
        item.maxAmount = getMaxAmount(item?.maxAmount)
        item.couponStatus = 1
        return item
    })
}




